module.exports = __webpack_public_path__ + "img/home-avatar.ed40e7c1.png";